/**
 * Breakpoints nommés alignés MUI : mobile (xs) / tablet (sm) / desktop (md) / wide (lg+).
 * xs: 0, sm: 600, md: 960, lg: 1280, xl: 1536
 */
export const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1536,
};
